import type { UpsertContactAttemptPayload } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { zodUpsertContactAttemptPayloadSchema } from './validations';

/**
 * Creates or updates a contact attempt for a supplier data exchange.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Exchange/operation/add_contact_attempts_data_exchange_contact_attempt_put
 */
export const upsertContactAttempt = async (
  payload: UpsertContactAttemptPayload,
) => {
  await vestigasApi
    .put(ENDPOINT.DATA_EXCHANGE.CREATE_CONTACT_ATTEMPT(), {
      json: payload,
      validate: {
        body: zodUpsertContactAttemptPayloadSchema,
      },
    })
    .json();
};
